// ALMONPLEX ortak sepete-ekle: Dawn cart drawer'ini yenile + AC
window.axAddToCart = function(vid, qty, btn, label){
  label = label || 'ADD';
  if (btn) btn.textContent = '...';
  var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  var body = { items: [{ id: vid, quantity: qty || 1 }] };
  if (cart && cart.getSectionsToRender) {
    try {
      body.sections = cart.getSectionsToRender().map(function(s){ return s.id; });
      body.sections_url = window.location.pathname;
    } catch(e){}
  }
  fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
    .then(function(r){ return r.json(); })
    .then(function(state){
      if (btn) { btn.textContent = '\u2713'; setTimeout(function(){ btn.textContent = label; }, 1600); }
      var qv = document.getElementById('ax-qv');
      if (qv) qv.style.display = 'none';
      if (cart && cart.renderContents && state.sections) {
        cart.renderContents(state);           // Dawn'in kendi pipeline'i: drawer'i yeniler ve ACAR
      } else if (cart && cart.classList) {
        cart.classList.add('animate', 'active');
      } else {
        window.location.href = '/cart';
      }
    })
    .catch(function(){ if (btn) btn.textContent = label; });
};
